import React from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next"; // ✅ import translation hook
import "../Style/Hero.css";                
import heroImage from "../assets/hero1.jpg";

export default function Hero() {
  const { t } = useTranslation(); // ✅ initialize translation

  return (
    <section className="hero" style={{ backgroundImage: `url(${heroImage})` }}>
      <div className="hero-overlay"></div>

      <Container className="hero-content text-center">
        <h1>{t("Falcon Star Stamps")}</h1>  {/* Translatable title */}
        <p>{t("Premium custom stamps, seals, and urgent deliveries across Abu Dhabi. Fast, precise, and professional for every business need.")}
          
        </p>      {/* Translatable description */}
        <a href="https://wa.me/+971559139165" target="_blank" rel="noreferrer" className="btn btn-lg rounded-pill px-4 hero-btn">
          {t("Order Now")}    
              {/* Translatable button */}
        </a>
      </Container>
    </section>
  );
}
